export const updateNestedAttributes = (
  item,
  nestedAttributesArray,
  attributesJS,
) => {
  if (nestedAttributesArray.includes(item.id) && Array.isArray(item.value)) {
    const updatedValue = item.value.map(elem => {
      const matchedAttribute = attributesJS[item.id]?.find(
        attr => attr.id === elem.id,
      );

      const newDescription = matchedAttribute
        ? matchedAttribute.description
        : elem.description;

      return { ...elem, description: newDescription };
    });

    return {
      ...item,
      value: updatedValue || item.value,
    };
  }
  return item;
};
